import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const DateField = ({
  name,
  placeholder,
  displayName,
  icon,
  value,
  error,
  touched,
  shrink,
  handleChange,
  classes,
  disabled,
}) => {
  const { t } = useTranslation();
  const shrinkField = shrink ? ' shrink-field' : '';
  const shrinkLabel = shrink ? ' shrink-label' : '';

  return (
    <div className={`custom-input-box${classes ? ' ' + classes : ''}`}>
      {displayName && (
        <label
          htmlFor={name}
          className={!touched && error ? 'label-error' + shrinkLabel : shrinkLabel}
        >
          {t(displayName)}
        </label>
      )}
      <div className='custom-input-field'>
        <input
          type='date'
          disabled={disabled}
          id={name}
          name={name}
          className={!touched && error ? 'input-error' + shrinkField : shrinkField}
          placeholder={t(placeholder)}
          value={value}
          onChange={(e) => handleChange(e.target.name, e.target.value)}
        />
        {icon && <img src={icon} className='icon' />}
      </div>
      {!touched && error && <p className='form-field-error'>{t(error)}</p>}
    </div>
  );
};

DateField.propTypes = {
  name: PropTypes.string.isRequired,
  displayName: PropTypes.string,
  placeholder: PropTypes.string,
  icon: PropTypes.string,
  value: PropTypes.string.isRequired,
  error: PropTypes.string,
  touched: PropTypes.bool,
  shrink: PropTypes.bool,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  classes: PropTypes.string,
};

export default DateField;
